import Actions from 'redux/actions'
import type { CallAPIAction, Status } from 'api/types'
import { FailResponse } from 'api/evisaAPI/dlAPI'

type State = { error: string } & Status

const initialState = {
  isLoading: false,
  success: false,
  fail: false,
  error: '',
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.CANCEL_REPORT_RUNAWAY_LABORER_ASYNC,
    Actions.CANCEL_REPORT_RUNAWAY_LABORER_SUCCESS,
    Actions.CANCEL_REPORT_RUNAWAY_LABORER_FAIL,
    {},
    FailResponse
  >,
): State => {
  switch (action.type) {
    case Actions.CANCEL_REPORT_RUNAWAY_LABORER_ASYNC:
    case Actions.CANCEL_REPORT_RUNAWAY_LABORER_SUCCESS: {
      return {
        ...state,
        ...action.status,
      }
    }
    case Actions.CANCEL_REPORT_RUNAWAY_LABORER_FAIL: {
      return {
        ...state,
        ...action.status,
        error: action.payload?.error.message || '',
      }
    }
    default:
      return state
  }
}
